import { Link } from "react-router-dom";
import { store } from "@STORE";
import { Translation, useTranslation } from "react-i18next";
import {
  HomeOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const TransGenerator = ({ to = "", text }) => {
  const { t } = useTranslation();
  return <>{to ? <Link to={to}>{t(text)}</Link> : <>{t(text)}</>}</>;
};

const navigateItemList = (functionIsShow) => {
  const {
    user: { SiteUser },
  } = store.getState(); // ← 從 Redux 拿使用者資料

  return [
    getItem(
      <TransGenerator to="/" text="NavBar.Home" />,
      "app",
      <HomeOutlined />
    ),
    getItem(
      <TransGenerator text="NavBar.Manage.Title" />,
      "user",
      <AppstoreOutlined />,
      [
        getItem(
          <TransGenerator
            to="/user/enterprise"
            text="NavBar.Manage.Enterprise"
          />,
          "enterprise"
        ),
        getItem(
          <TransGenerator to="/user/account" text="NavBar.Manage.Account" />,
          "account"
        ),
        functionIsShow
          ? getItem(
              <TransGenerator
                to="/user/functionList"
                text="NavBar.Manage.Function"
              />,
              "function"
            )
          : null,
      ]
    ),
    ...(SiteUser !== "III"
      ? [
          getItem(
            <TransGenerator to="/list" text="NavBar.LCAs.List" />,
            "list",
            <UnorderedListOutlined />
          ),
          getItem(
            <TransGenerator to="/dashboard" text="NavBar.Dashboard" />,
            "dashboard",
            <BarChartOutlined />
          ),
        ]
      : []),
  ];
};

export default navigateItemList;
